/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="61.19"
        height="95.58"
        viewBox="0 0 61.19 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M51.04 0a1.24 1.24 0 0 1 1.16.8v.12l3.07 11.15-2.41.66L50.04 2.5H11.22L8.41 12.73l-2.37-.66 3-11.15a1.25 1.25 0 0 1 1.1-.92Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M57.78 11.15H3.48a1.25 1.25 0 0 0-1.21.92L.04 20.29a1.26 1.26 0 0 0 .89 1.53 1.17 1.17 0 0 0 .32 0h58.69a1.24 1.24 0 0 0 1.25-1.24 1.26 1.26 0 0 0-.05-.33l-2.1-8.18a1.24 1.24 0 0 0-1.26-.92Zm-1 2.5 1.53 5.67H2.92l1.52-5.67Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M56.04 19.29a1.25 1.25 0 0 1 1.25 1.25v.16l-2 15.05-2.48-.32 1.78-13.64h-48l1.85 13.64-2.48.32L4.04 20.7a1.26 1.26 0 0 1 1.09-1.4h50.91ZM47.72 74.76l2.48.32-2.53 19.41a1.25 1.25 0 0 1-1.12 1.09H14.87a1.25 1.25 0 0 1-1.22-1v-.13l-2.54-19.41 2.48-.32 2.39 18.32H45.3Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M56.04 34.37H5.23a1.24 1.24 0 0 0-1.19 1.3v.09l4.33 39.29a1.25 1.25 0 0 0 1.24 1.12h42.11a1.26 1.26 0 0 0 1.25-1.12l4.33-39.29a1.25 1.25 0 0 0-1.12-1.38Zm-1.39 2.5-4.06 36.8H10.72l-4-36.8Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'CoffeeCupDisposableIcon';

export default Icon;
